<template>
  <div class="addUsdtCard-page">
    <div class="head_area">
      <div class="leftImg">
        <van-icon name="arrow-left" @click="$router.back()" />
      </div>
      <span class="head_text">{{ $t('新增USDT地址') }}</span>
      <span class="right_menu"></span>
    </div>
    <div class="content">
      <div class="tipsh">
        <div class="tops">{{ $t('USDT价格稳定') }} {{ $t('流通性高') }} {{ $t('不受监管') }}
          <span @click="$parent.goNav('/usdtmore')">
            {{ $t('了解更多') }}
            <img src="/static/image/new/arrow-blue.png" alt="">
          </span>
        </div>
        <div class="tsg">
          <div class="tsgs">{{ $t('绑定协议地址') }}</div>
          <div class="tsgs">{{ $t('交易所划转') }}</div>
          <div class="tsgs">{{ $t('完成取款') }}</div>
        </div>
      </div>
      <div class="usrse">
        <div class="hgs">
          <div class="nams sc">
            {{ $t('钱包协议') }}
          </div>
          <div class="protocol-box">
            <div :class="usdtInfo.bank_owner == 'TRC20' ? ' ssa acti' : 'ssa'" @click="changXie('TRC20')">TRC20</div>
            <div :class="usdtInfo.bank_owner == 'ERC20' ? ' ssa acti' : 'ssa'" style="margin-left: 0.5rem" @click="changXie('ERC20')">ERC20</div>
          </div>
        </div>
        <div class="hgs">
          <div class="nams">{{ $t('USDT地址') }}</div>
          <div class="input-box">
            <input type="text" readonly onfocus="this.removeAttribute('readonly');" auto-complete="off" onblur="this.setAttribute('readonly',true);"  v-model="usdtInfo.bank_no" :placeholder="$t('请输入USDT地址')" class="van-field__control" />
          </div>
        </div>
        <div class="hgs">
          <div class="nams">{{ $t('支付密码') }}</div>
          <div class="input-box">
            <input v-model="usdtInfo.pay_pass" type="password" :placeholder="$t('请输入支付密码')" >
          </div>
        </div>
        <div class="submit" @click="bindUsdss">{{ $t('确认添加') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import {translateText} from "../common/utils";

export default {
  name: 'addUsdtCard',
  data() {
    return {
      usdtInfo: { bank_owner: 'TRC20' },
    };
  },
  created() {
    let that = this;
  },
  methods: {
    changXie(name) {
      this.usdtInfo.bank_owner = name;
    },
    async showTost(type = 0, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    bindUsdss() {
      let that = this;
      let usdtInfo = that.usdtInfo;
      usdtInfo.bank = 'USDT';
      if (usdtInfo.bank_no == null || usdtInfo.bank_no == '') {
        that.showTost(0, that.$t('请输入USDT地址'));
        return;
      }
      if (!usdtInfo.bank_owner || usdtInfo.bank_owner == null) {
        that.showTost(0, that.$t('请选择钱包协议'));
        return;
      }
      if (!usdtInfo.pay_pass) {
        that.showTost(0, that.$t('请输人支付密码'));
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bindcard', usdtInfo)
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.showTost(1, res.message);
            that.$router.back();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
.addUsdtCard-page {
  width: 100%;
  height: 100vh;
  background-color: #000;
  color: #fff;
  font-family: PingFang SC;
  background-image: url("/static/image/new/page-bg-img.png");
  background-size: cover;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .head_area {
    position: relative;
    z-index: 2;
    height: 1.33333rem;
    display: flex;
    align-items: center;
    padding: 0 .4rem;
    .leftImg {
      flex: 1;
      text-align: left;
      font-size: .48rem;
    }
    .top_back {
      width: 0.26rem;
      height: 0.37333rem;
    }
    .head_text {
      font-size: 0.48rem;
      color: #fff;
      width: 55%;
      text-align: center;
    }
    .right_menu {
      font-size: 0.37333rem;
      color: #fff;
      flex: 1;
      text-align: right;
    }
  }
  .content {
    flex: 1;
    overflow: auto;
    padding: 0 .4rem;
    .tipsh {
      width: 100%;
      border-radius: .19rem;
      background: rgba(255, 255, 255, 0.10);
      border: 0.03rem solid rgba(255, 255, 255, 0.10);
      box-sizing: border-box;
      padding: .43rem .27rem .29rem;

      .tops {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 0.37rem;
        font-weight: 600;
        span {
          font-size: 0.27rem;
          color: #4B5BF1;
          font-weight: 500;
          display: flex;
          align-items: center;
          img {
            width: 0.24rem;
            height: 0.24rem;
            margin-left: .11rem;
          }
        }
      }
      .tsg {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: .37rem;
        .tsgs {
          color: #BBBBBB;
          font-size: 0.27rem;
          text-align: center;
          padding: 0 .1rem;
          flex: 1;
        }
      }
    }
    .usrse {
      box-sizing: border-box;
      .hgs {
        margin-top: .27rem;
        border-radius: .19rem;
        background: rgba(255, 255, 255, 0.10);
        border: 0.03rem solid rgba(255, 255, 255, 0.10);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 .27rem;
        height: 1.49rem;
        .protocol-box {
          display: flex;
          align-items: center;
          .ssa {
            border-radius: .5rem;
            border: .03rem solid rgba(255, 255, 255, 0.10);
            background: rgba(255, 255, 255, 0.10);
            width: 2.56rem;
            height: 0.96rem;
            line-height: 0.96rem;
            font-size: 0.43rem;
            font-weight: bold;
            text-align: center;
            margin-left: .27rem;
          }
          .acti {
            background: linear-gradient(to bottom, #4B5BF1 40%, #B5BBF8);
            border-color: #4B5BF1;
          }
        }
      }
      .nams {
        font-size: 0.37rem;
        font-weight: bold;
        vertical-align: middle;
      }
      .imgsa {
        position: relative;
        height: 2rem;
        border-bottom: 1px solid #f2f2f2;
        padding-bottom: 0.2rem;
        .bisn {
          width: 0.8rem;
          position: absolute;
          bottom: 0.3rem;
          left: 1.4rem;
        }
        img {
          width: 2rem;
          border-radius: 50%;
        }
      }
    }
    .input-box {
      height: 100%;
      width: 60%;
      input {
        width: 100%;
        height: 100%;
        background: transparent;
        outline: none;
        border: none;
        text-align: right;
        color: #fff;
        &::-webkit-input-placeholder {
          font-size: 0.32rem;
          color: #bbb;
        }
      }
      input:-webkit-autofill,
      input:-webkit-autofill:hover,
      input:-webkit-autofill:focus {
        -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
        box-shadow: 0 0 0px 1000px transparent inset !important;
        -webkit-text-fill-color: #fff !important; /* 保持文本颜色继承 */
        transition: background-color 9999s ease-out 0s !important;
      }

    }
    .submit {
      width: 100%;
      height: 1.23rem;
      border-radius: .6rem;
      margin-top: 1.07rem;
      background: linear-gradient(to bottom, #4B5BF1 40%, #B5BBF8);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.43rem;
      font-weight: 600;
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/components/addUsdtCard.vue